<template id="historicalTraffic">
  <div >
    <div>
      <span style="font-size: 14px;color: rgba(0, 0, 0, 0.85);font-weight: bold">
      选择时间:
    </span>
      <a-range-picker
          style="width:320px;margin-right:12px"
          v-model="timeSelect"
          show-time
          :change="onChange()"
      />
      <span v-if="!gatewayCodeProps" style="font-size: 14px;color: rgba(0, 0, 0, 0.85);font-weight: bold;">
      网关编号:
      </span>
      <a-input
          v-if="!gatewayCodeProps"
          style="width:250px;margin-right:12px"
          v-model="gatewayCode"
          prop="true"
      >
      </a-input>
      <a-button-group>
        <a-button type="primary" @click="searchTrafficDiffData()">
          {{ $t('search') }}
        </a-button>
        <a-button type="primary" @click="clera()" style="margin-left: 3px">
          {{ $t('common_reset') }}
        </a-button>
      </a-button-group>
    </div>

    <a-modal v-model="showSaveModal" title="提示" @ok="handleOkModal" okType="primary">
      <p>{{ this.message }}</p>
    </a-modal>

    <div >
      <span
          style="font-size: 14px;position: absolute;right:6%;margin-top:15px;
          color: rgba(0, 0, 0, 0.85);
          font-weight: bold;"
      >
      时间粒度:
      <a-select
          style="width:150px;z-index:20;"
          v-model="timeIntervalCode"
          placeholder="请选择"
          @change="handleChange"
          :disabled="disabled"
      >
        <a-select-option value="5m">每5分钟</a-select-option>
        <a-select-option value="1h">每小时</a-select-option>
        <a-select-option value="1d">每天</a-select-option>
      </a-select>
      </span>
      <template style="">
        <trafficDiffLineChart
            :visible="true"
            style=";margin-top:20px;min-width: 700px"
            ref="tdl"
            :total="total"
            :tras="tras"
            :dataTimes="dataTimes"
            :max="max"
            :min="min"
            :avg="avg"
            :width="width"
        >
        </trafficDiffLineChart>
      </template>
    </div>

  </div>
</template>
<script>
import trafficDiffLineChart from "@/views/console/remote-connect-manage/component/TrafficDiffLineChart.vue"
import {
  QueryTrafficDiffVO,
  IotExtranetTrafficServiceProxy
} from "@/service-proxies/app-v2/iotmodel-storage.service-proxies";
import moment from 'moment';

const ecsp = new IotExtranetTrafficServiceProxy()
export default {
  name: "historicalTraffic",
  components: {trafficDiffLineChart},
  data() {
    return {
      timeSelect: undefined,
      startTime: undefined,
      endTime: undefined,
      gatewayCode: '',
      myChart: null,
      total: 0.0,
      max: 0.0,
      min: 0.0,
      avg: 0.0,
      tras: [],
      dataTimes: [],
      message: '',
      disabled: false,
      showSaveModal: false,
      timeIntervalCode: '5m',
      timeLineHeight: "",
    }
  },
  props:{
    gatewayCodeProps:{
      type:String,
      default:''
    },
    width: {
      type: String,
      default: '100%'
    }
  },
  mounted() {
    this.$nextTick(() => this.$refs.tdl.initEcharts())
    this.timeLineHeight = document.documentElement.clientHeight - 210;
    window.onresize = () => {
      this.timeLineHeight = document.documentElement.clientHeight - 210;
    }
    this.resetTime();

  },
  methods: {
    async reload() {
      this.total = 0.0,
      this.max = 0.0,
      this.min = 0.0,
      this.avg = 0.0,
      this.tras = [],
      this.dataTimes = [],
      this.timeSelect = undefined
      this.$refs.tdl.reload()
    },
    resetTime(){
      const now = moment();
      const yestoday = moment().subtract(1,'day');
      this.timeSelect=[yestoday,now]

      this.startTime = Date.parse(new Date(yestoday._d)).toString()
      this.endTime = Date.parse(new Date(now._d)).toString()

    },
    onChange() {
      if (this.timeSelect && this.timeSelect.length > 0) {
        this.startTime = Date.parse(new Date(this.timeSelect[0]._d)).toString()
        this.endTime = Date.parse(new Date(this.timeSelect[1]._d)).toString()
      } else {
        this.startTime = ''
        this.endTime = ''
      }
    },
    searchData(startTime,endTime){
      this.startTime = startTime
      this.endTime = endTime
      this.timeSelect = [moment(startTime),moment(endTime)]
      this.searchTrafficDiffData()
    },

    handleOkModal() {
      this.showSaveModal = false
    },
    clera() {
      this.timeSelect = undefined
      this.gatewayCode = ''
      this.startTime = ''
      this.endTime = ''
      this.resetTime();
      this.searchTrafficDiffData();
    },
    searchTrafficDiffData() {
      this.gatewayCode = this.gatewayCodeProps
      if (!this.timeSelect) {
        this.message = '请选择时间范围'
        this.showSaveModal = true
        return
      }
      if (!this.gatewayCode) {
        this.message = '请填写网关'
        this.showSaveModal = true
        return
      }

      if (!this.timeIntervalCode) {
        this.timeIntervalCode = '5m'
      }

      this.disabled = true
      let params = {
        startTime: this.startTime,
        endTime: this.endTime,
        gatewayCode: this.gatewayCode,
        timeIntervalCode: this.timeIntervalCode
      }
      const gs = new QueryTrafficDiffVO()
      gs.init(params)
      ecsp.getTrafficDiffData(gs).then(res => {
        if (res.data) {
          this.total = res.data.total
          this.tras = res.data.tras
          this.max = res.data.max
          this.min = res.data.min
          this.avg = res.data.avg
          this.dataTimes = res.data.dataTimes
          // this.$refs.tdl.setOption()
        } else {
          this.message = res.msg
          this.showSaveModal = true
        }
      }).finally(() => {
        this.disabled = false
      })
    },
    handleChange(e) {
      if (e) {
        this.timeIntervalCode = e
        if (this.timeSelect && this.gatewayCode) {
          this.searchTrafficDiffData()
        }
      }
    }
  },
  watch:{
    gatewayCodeProps(){
      this.$nextTick(()=>{
        this.reload()
      })
    }
  }


}
</script>

<style scoped>

</style>